const sideNavEl = document.querySelector('.side-nav-container');
const contentContainer = document.querySelector('.content-container');
const resourceCategories = document.querySelector('.multicolumn__small');
const contentHeading = document.getElementById('content-title-heading');

const lookUpContent = async function(handle) {
    try {
        const response = await fetch(`/pages/${handle}`);

        if (!response.ok) {
            throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
        }
        
        const responseText = await response.text();
        const parser = new DOMParser();
        const html = parser.parseFromString(responseText, 'text/html');

        return html.body;
        
    } catch (error) {
        console.error(error);
        throw error;
    }
}

const displayContent = function(html) {
    const content = html.querySelector('.content-for-resources-page');
    contentContainer.innerHTML = "";
    contentContainer.appendChild(content)
}

const changeActiveLink = function(el) {
    const list = el.closest('.side-nav-list');
    const linksArr = list.querySelectorAll('.side-nav-list-item');

    linksArr.forEach(el => el.classList.remove('active-link'));
    el.classList.add('active-link');
}

const changeActiveList = function(el) {
    const list = el.closest('.multicolumn__small-item').dataset.resourceSection;
    const itemArr = resourceCategories.querySelectorAll('.multicolumn__small-item');

    itemArr.forEach(el => el.classList.remove('active-item'));
    el.classList.add('active-item');

    const linksLists = sideNavEl.querySelectorAll('.side-nav-list');
    linksLists.forEach((el) => {
        if (el.dataset.resourceLinksList === list) {
            el.classList.add('active-list');
        } else {
            el.classList.remove('active-list');
        }
    })
}

const grabURL = function() {
  if (!window.location.href.includes('#')) return false;
  currentURL = window.location.href;
  return currentURL.split('#')[1];
}

const updateContentOnLoad = function() {
    const handle = grabURL() || "about-our-rugs";
    handle ? updateContent(handle) : updateContent("about-our-rugs")

    const el = document.querySelector(`[data-resource-id=${handle}]`);
    changeActiveLink(el);

    const list = el.closest('.side-nav-list').dataset.resourceLinksList;
    const multiEl = resourceCategories.querySelector(`[data-resource-section=${list}]`);
    changeActiveList(multiEl);
}

const updateContent = async function(handle) {
    const html = await lookUpContent(handle);
    contentHeading.textContent = document.querySelector(`[data-resource-id=${handle}] h5`).textContent
    displayContent(html);
    window.history.replaceState('', 'Resources', `resources#${handle}`);
}

const updateCategory = function(el) {
    const clickedListName = clicked.dataset.resourceSection;
    const clickedList = Array.from(sideNavEl.querySelectorAll('.side-nav-list')).find(el => el.dataset.resourceLinksList === clickedListName);
    const activeLink = clickedList.querySelector('.active-link');
    const handle = activeLink.dataset.resourceId;
    updateContent(handle);
}

sideNavEl.addEventListener('click', async function(e) {
    clicked = e.target.closest('.side-nav-list-item');
    if (!clicked) return;

    changeActiveLink(clicked)

    const handle = clicked.dataset.resourceId;
    updateContent(handle);   
});

resourceCategories.addEventListener('click', async function(e) {
    clicked = e.target.closest('.multicolumn__small-item');
    if (!clicked) return;

    changeActiveList(clicked);
    updateCategory(clicked);
})

updateContentOnLoad();